import { INeoAction } from './../Actions.interface';
import { REQUEST_ACTIONS, STATIC_ACTIONS, STATUS } from '../../Constants/Actions.constants';
import { UploadedImage } from '../../Models/interfaces/UploadedImage.model';

export default (state = {}, action: INeoAction): UploadedImage => {
  const { name, payload, status } = action;

  if (name === STATIC_ACTIONS.CLEAR_IMAGE_UPLOAD) {
    return {};
  }

  if (name === REQUEST_ACTIONS.UPLOAD_IMAGE && status === STATUS.SUCCESS) {
    return payload;
  }

  return state;
};
